// Sample values shown in the admin preview; the real email substitutes per-customer data server-side.
export const fillTemplateVariables = (body: string): string =>
  body
    .replace(/\{\{customer_first_name\}\}/g, 'Jane')
    .replace(/\{\{customer_last_name\}\}/g, 'Doe')
    .replace(/\{\{technician_name\}\}/g, 'John Smith')
    .replace(/\{\{technician_signature\}\}/g, 'John Smith');

export const buildPreviewHtml = (body: string): string => `
<!DOCTYPE html>
<html>
  <head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <style>
      @font-face { font-family: 'AlexBrush'; src: url('/assets/fonts/AlexBrush-Regular.ttf') format('truetype'); font-weight: normal; font-style: normal; }
      body { font-family: Arial, Helvetica, sans-serif; margin: 0; padding: 0; background-color: #f4f4f4; }
    </style>
  </head>
  <body>
    <table role="presentation" width="100%" cellpadding="0" cellspacing="0" style="background-color: #f4f4f4;">
      <tr>
        <td align="center" style="padding: 24px 16px;">
          <table role="presentation" width="600" cellpadding="0" cellspacing="0" style="max-width: 600px; background-color: #ffffff; border-radius: 8px; overflow: hidden; box-shadow: 0 2px 8px rgba(0,0,0,0.08);">
            <tr>
              <td align="center" style="padding: 28px 40px 20px; background-color: #ffffff;">
                <img src="/home_inspections_logo.png" alt="TUDI Home Services" width="280" style="display: block; max-width: 280px; height: auto;" />
              </td>
            </tr>
            <tr>
              <td style="padding: 0 40px;">
                <hr style="border: none; border-top: 2px solid #96052F; margin: 0;" />
              </td>
            </tr>
            <tr>
              <td style="padding: 32px 40px; color: #333333; font-size: 15px; line-height: 1.7; font-family: Arial, Helvetica, sans-serif;">
                ${body}
              </td>
            </tr>
            <tr>
              <td style="background-color: #96052F; padding: 20px 40px; text-align: center;">
                <p style="margin: 0; color: #ffffff; font-size: 13px; font-family: Arial, Helvetica, sans-serif;">
                  TUDI Home Services &bull; <a href="mailto:info@tudi.com" style="color: #ffffff; text-decoration: underline;">info@tudi.com</a>
                </p>
                <p style="margin: 8px 0 0; color: rgba(255,255,255,0.7); font-size: 11px; font-family: Arial, Helvetica, sans-serif;">
                  &copy; ${new Date().getFullYear()} TUDI Mechanical Systems. All rights reserved.
                </p>
              </td>
            </tr>
          </table>
        </td>
      </tr>
    </table>
  </body>
</html>
`;
